export const IS_INIT_TIME_TABLE_OPEN = 'initTimeTable/IS_INIT_TIME_TABLE_OPEN';
export const CHANGE_STEP = 'initTimeTable/CHANGE_STEP';
export const IS_INIT_TIME_TABLE_POPUP_OPEN = 'initTimeTable/IS_INIT_TIME_TABLE_POPUP_OPEN';